import { render, staticRenderFns } from "./DataOnlyCard.vue?vue&type=template&id=618b739a&"
import script from "./DataOnlyCard.vue?vue&type=script&lang=js&"
export * from "./DataOnlyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports